module.exports = __webpack_public_path__ + "img/front.027cf745.jpg";